// SignUp.js
import "./SignUp.scss";
import { Helmet } from "react-helmet";

import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPage } from "../../actions";

import { fatBastard } from "../../apis/fatBastard";

// ✅ GA helper (gtag OR GTM)
function trackSignupGA({ method = "newsletter" } = {}) {
    // gtag.js
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "sign_up", { method });
        return;
    }

    // Google Tag Manager
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
            event: "sign_up",
            method,
        });
    }
}

class SignUp extends Component {
    state = {
        form: {
            first_name: "",
            last_name: "",
            country: "",
            city: "",
            mobile: "",
            email: "",
            dob: "",
            consent: false,
        },
        loading: false,
        successMsg: "",
        errorMsg: "",
    };

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        this.setState((prev) => ({
            form: {
                ...prev.form,
                [name]: type === "checkbox" ? checked : value,
            },
        }));
    };

    submit = async (e) => {
        e.preventDefault();

        this.setState({ loading: true, successMsg: "", errorMsg: "" });

        try {
            const response = await fatBastard.post("/subscribe", this.state.form);

            if (response.data?.success === false) {
                throw new Error(response.data?.message || "Subscription failed.");
            }

            // ✅ Track registration in GA (only after success)
            trackSignupGA({ method: "newsletter" });

            // ✅ Redirect to success page
            window.location.href = "/sign-up/success";

            // (No need to reset state because you're navigating away)
        } catch (err) {
            const validation =
                err?.response?.data?.errors
                    ? Object.values(err.response.data.errors).flat().join(" ")
                    : null;

            const message =
                validation ||
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.message ||
                "Something went wrong.";

            this.setState({ errorMsg: message });
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        if (!this.props.isVerified) return <div>loading</div>;

        const { form, loading, successMsg, errorMsg } = this.state;

        return (
            <div className="signup-page">
                <Helmet>
                    <title>FAT bastard Wines | Subscribe</title>
                </Helmet>

                <div className="signup-container">
                    <h1 className="signup-title">
                        Join the LIVE <em>large</em> family&nbsp;
                        <span className="desktop-break"><br /></span>
                         and save 15%
                    </h1>

                    <p className="signup-subtitle">
                        Sign up for news, competitions, and exclusive offers - and get 15% off your wine purchase
                        when you join. By subscribing, you confirm you're of legal drinking age.
                    </p>

                    {successMsg ? (
                        <div className="signup-alert signup-alert--success">{successMsg}</div>
                    ) : null}

                    {errorMsg ? (
                        <div className="signup-alert signup-alert--error">{errorMsg}</div>
                    ) : null}

                    <form className="signup-form" onSubmit={this.submit}>
                        <div className="signup-grid">
                            <input
                                className="signup-input"
                                type="text"
                                name="first_name"
                                placeholder="Name"
                                value={form.first_name}
                                onChange={this.handleChange}
                                required
                            />

                            <input
                                className="signup-input"
                                type="text"
                                name="last_name"
                                placeholder="Surname"
                                value={form.last_name}
                                onChange={this.handleChange}
                                required
                            />

                            <div className="signup-selectWrap">
                                <select
                                    className="signup-select"
                                    name="country"
                                    value={form.country}
                                    onChange={this.handleChange}
                                    required
                                >
                                    <option value="" disabled>
                                        Country
                                    </option>
                                    <option value="South Africa">South Africa</option>
                                    <option value="Botswana">Botswana</option>
                                    <option value="Namibia">Namibia</option>
                                    <option value="Zimbabwe">Zimbabwe</option>
                                    <option value="Zambia">Zambia</option>
                                    <option value="Kenia">Kenia</option>
                                    <option value="Tanzania">Tanzania</option>
                                    <option value="Uganda">Uganda</option>
                                    <option value="Ghana">Ghana</option>
                                    <option value="Nigeria">Nigeria</option>
                                    <option value="United Arab Emirates">United Arab Emirates</option>
                                </select>
                            </div>

                            <input
                                className="signup-input"
                                type="text"
                                name="city"
                                placeholder="City"
                                value={form.city}
                                onChange={this.handleChange}
                                required
                            />

                            <input
                                className="signup-input"
                                type="tel"
                                name="mobile"
                                placeholder="Cell Number"
                                autoComplete="tel"
                                value={form.mobile}
                                onChange={this.handleChange}
                            />

                            <input
                                className="signup-input"
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                autoComplete="email"
                                value={form.email}
                                onChange={this.handleChange}
                                required
                            />

                            <div className="signup-dateWrap signup-input--full">
                                <input
                                    className="signup-input signup-date"
                                    type="date"
                                    name="dob"
                                    id="dob"
                                    placeholder=" "
                                    value={form.dob}
                                    onChange={this.handleChange}
                                    required
                                />
                                <label className="signup-dateLabel" htmlFor="dob">
                                    Date of Birth
                                </label>
                            </div>
                        </div>

                        <div className="signup-footer">
                            <label className="signup-consent">
                                <input
                                    className="signup-checkbox"
                                    type="checkbox"
                                    name="consent"
                                    checked={form.consent}
                                    onChange={this.handleChange}
                                    required
                                />
                                <span>
                  I agree to receive marketing communications and acknowledge that my data will be processed
                  in accordance with the{" "}
                                    <a href="/resources/PRIVACY-POLICY-ROBERTSON-WINERY.pdf">Privacy Policy</a>.
                </span>
                            </label>

                            <button className="signup-submit" type="submit" disabled={loading} style={{
                                width: '100%',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px',
                                fontWeight: 'lighter',
                            }}>
                                {loading ? "SUBSCRIBING..." : "SUBSCRIBE"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    page: state.page,
    isVerified: state.isVerified,
});

export default connect(mapStateToProps, { fetchPage })(SignUp);
